import { LinearProgress } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import ListingTable from "../../../listing/listing";

export const ConflictFullDayEvents = ({ conflictingFulldayEventFetched }) => {

    const [conflictingFulldayEventList, setConflictingFulldayEventList] = useState([]);
    const [listFetchSuccess, setListFetchSuccess] = useState(false);
    const [loaderFlag, setloaderFlag] = useState(true);

    const conflictingFulldayEvents = {
        tableId: "conflictingFulldayEventLists",
        tableTitle: "Conflicting Fullday Events",
        showReload: true,
        showFilter: true,
        api: {
            url: process.env.REACT_APP_API_URL,
            endPoint: "calendarapi/conflict-fullday-event_list",
            // deleteSingleUserEndpoint: "api/delete-user",
            tableCountEndpoint: "calendarapi/conflict-fullday-event_list",
        },

        reqBody: {
            "condition": {
                "limit": 5,
                "skip": 0
            },
            "sort": {
                "field": "_id",
                "type": "desc"
            },
            "searchcondition": {
            },
            "count": false
        },
        deleteSingleUserReqBody: {
            source: "users",
            secret: "AZ|lepL`",
            // token: usersToken,
        },
        deleteMultipleReqBody: {
            source: "users",
            secret: "AZ|lepL`",
            // token: usersToken,
        },

        //******************************** By Default Rows per page option will be available**************************//

        rowsPerPageOptions: [5, 10, 20, 30],
        sortFields: ["time_diff_creation", "slot_start_time_unix", "slot_end_time_unix"],
        paginationType: "stackPagination",
        enableRowActionLoader: true,
        customBtnHead: [
            // {
            //     id: "deleteMultiple",
            //     type: "delete_icon",
            //     title: "Delete",
            // },
            // {
            //     id: "editMultiple",
            //     type: "toggle_on_icon",
            //     title: "Status Change",
            // },
            // {
            //     id: "adduser",
            //     type: "add_icon",
            //     title: "ADD USER",
            //     className: "add_user_icon",
            //     default: true,
            // },
        ],
        buttons: [
        ],
        deleteModal: {
            modalClassName: "Delete Modal Deletemodal",
        },

        searchBarData: {
            heading: "Search Conflicting Fullday Events",
            api: {
                url: process.env.REACT_APP_API_URL,
                endPoint: "calendarapi/conflict-fullday-event_list",
                tableCountEndpoint: "calendarapi/conflict-fullday-event_list",
                reqBody: {
                    // count:true,
                    // "source": "users",
                    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MzYzNTZkNDFjZTE3MzAwMDhiOGFhYTUiLCJzZWNyZXQiOiJ6R3RpMnY1enYiLCJpYXQiOjE2Njc5Njg3MzV9.wzFi1CoHbv9QK5cUHbVgSL6LW8m6fR_BaILcT7OcHBQ",
                    condition: {
                        limit: 5,
                        skip: 0,
                    },
                    sort: {
                        type: "desc",
                        field: "_id",
                    },
                },
            },

            searchSettings: {
                datesearch: [
                    // {
                    //     id: 0,
                    //     heading: "Search By Joining Date",
                    //     startdatelabel: "Start Date",
                    //     enddatelabel: "End Date",
                    //     className: "formGroup createdon_datetime countDiv__column--col4",
                    //     submit: "Search",
                    //     field: "start_datetime_unix",
                    // },
                ],
                selectsearch: [
                    // {
                    //     id: 1,
                    //     label: "Search By Status",
                    //     field: "status",
                    //     type: "select",
                    //     values: [0, 1],
                    //     // value: "",
                    // },


                ],
                textsearch: [
                    {
                        id: 1,
                        // heading: "Search By First Name",
                        label: "Search By Summary ",
                        field: "summary",
                        className: "formGroup summary countDiv__column--col4",
                        value: "",
                    },
                    {
                        id: 2,
                        // heading: "Search By First Name",
                        label: "Search By Organizer Email ",
                        field: "organizer_email",
                        className: "formGroup organizer_email countDiv__column--col4",
                        value: "",
                    },
                ],

            },
        },
    };




    var modifyTableHeaders =
        [
            { val: "summary", name: "Summary" },
            // { val: "connected_gmail", name: "connected_gmail" },
            { val: "organizer_email", name: "Organizer Email" },
            { val: "time_diff_creation", name: "Deletion Time(min)" },
            { val: "timespan", name: "Timespan" },
            { val: "slot_start_time_unix", name: "Appointment Start Time Unix", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },
            { val: "slot_end_time_unix", name: "Appointment End Time Unix", type: "dateTime", format: "DD/MM/YYYY hh:mm A" },

        ];

    const getList = async () => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(conflictingFulldayEvents.reqBody),
        };
        const response = await fetch(
            process.env.REACT_APP_API_URL + "calendarapi/conflict-fullday-event_list",
            requestOptions
        );
        const respdata = await response.json();
        console.log("++++cv+++++++", respdata);
        if (respdata && respdata.status === "success") {
            setConflictingFulldayEventList([...respdata.results.res])
        }
        setloaderFlag(false);
        conflictingFulldayEventFetched(true);
    }

    useEffect(() => {
        if (conflictingFulldayEventList && conflictingFulldayEventList.length === 0 && !listFetchSuccess) {
            setListFetchSuccess(true);
            getList();
        }

    }, [conflictingFulldayEventList]);


    return (
        <>
            {loaderFlag == true ? (
                <Box sx={{ width: "100%", mt: "10px" }}>
                    <app-progressbar />
                </Box>
            ) : (
                ""
            )}

            <div className="reactTableWrapper miscList">
                {!loaderFlag && conflictingFulldayEventList !== undefined ? (
                    <ListingTable
                        tableData={conflictingFulldayEvents}
                        dataset={conflictingFulldayEventList}
                        modifyHeaders={modifyTableHeaders}
                    />
                ) : ''}
            </div>
        </>
    )
}